import { LockKeyhole } from "lucide-react";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import {
  IgAvatar,
  IgButton,
  IgLink,
  IgTypography,
} from "@intelligems/ig-theme";
import { Box, Grid, useTheme } from "@mui/material";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import { styled } from "@mui/material/styles";
import { selectedIsShopLogin } from "@src/store/slices/appSettings";
import { logoutWithWorker } from "@src/utils";
import { appListing } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

import { IgErrorBoundary } from "../Utils/IgErrorBoundary";

import { ShopLogin } from "./ShopLogin";
import { UserPasswordLogin } from "./UserPasswordLogin";

const PREFIX = "LoginPage";

const classes = {
  paper: `${PREFIX}-paper`,
  avatar: `${PREFIX}-avatar`,
};

const StyledContainer = styled(Container)(({ theme }) => ({
  [`& .${classes.paper}`]: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  [`& .${classes.avatar}`]: {
    margin: theme.spacing(1),
    backgroundColor: theme.igBackgroundColors.accentSolid,
  },
}));

export default function LoginPage() {
  const theme = useTheme();
  const isShopLogin = useSelector(selectedIsShopLogin);
  useEffect(() => {
    if (window.location.href.includes("logout")) {
      logoutWithWorker();
    }
  }, []);

  return (
    <StyledContainer maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <IgAvatar variant={"circular"} className={classes.avatar}>
          <LockKeyhole color={theme.igIconColors.dark} />
        </IgAvatar>
        <IgTypography variant={"h1"}>Sign in</IgTypography>
        <Grid
          item
          xs
          style={{ width: "100%", marginTop: "5px", marginBottom: "5px" }}
        >
          <IgButton
            onClick={() => {
              openNewTab(appListing, "Login Page - Download App");
            }}
            fullWidth
            variant={"text"}
          >
            Don't have an account? Download Intelligems now!
          </IgButton>
        </Grid>
        <IgErrorBoundary>
          {isShopLogin ? <ShopLogin /> : <UserPasswordLogin />}
        </IgErrorBoundary>
      </div>
      <Box mt={2} mb={2}>
        <Grid container direction={"row"} justifyContent={"center"}>
          <IgTypography variant="body2" color={theme.palette.text.secondary}>
            {"Copyright © "}
            <IgLink variant="body2" href="intelligems.io/">
              Intelligems, Inc
            </IgLink>{" "}
            {new Date().getFullYear()}
            {"."}
          </IgTypography>
        </Grid>
      </Box>
    </StyledContainer>
  );
}
